import PropTypes from 'prop-types';
import React from 'react';

const Visa = ({ className, active }) => (
  <svg
    className={className}
    viewBox="0 0 30 10"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        x1="49.5802%"
        y1="-2.0062%"
        x2="50.5086%"
        y2="100%"
        id="visa-a"
      >
        <stop stopColor="#222357" offset="0%" />
        <stop stopColor="#254AA5" offset="100%" />
      </linearGradient>
    </defs>
    <path
      d="M15.5153 6.5906c-.0171-1.3495 1.2026-2.1026 2.1215-2.5503.944-.4594 1.2612-.754 1.2576-1.1648-.0072-.6288-.7531-.9062-1.4513-.917-1.218-.019-1.926.3288-2.489.5918l-.4388-2.053C15.0802.2369 16.1261.0099 17.2107 0c2.5458 0 4.2114 1.2567 4.2204 3.2052.01 2.4728-3.4205 2.6098-3.397 3.7151.008.3351.3279.6928 1.0287.7837.3468.046 1.3044.0811 2.39-.4189l.426 1.9864c-.5837.2126-1.334.4162-2.2683.4162-2.3962 0-4.0817-1.2738-4.0952-3.0971m10.458 2.926c-.465 0-.8568-.2712-1.0316-.6874L21.305.1459h2.544l.5063 1.399h3.1088l.2937-1.399H30l-1.9566 9.3706h-2.0702m.3558-2.5313l.7342-3.5187h-2.0107l1.2765 3.5187M12.4308 9.5165L10.4255.146h2.4242l2.0044 9.3706h-2.4233m-3.5863 0l-2.5233-6.378-1.0206 5.4231c-.1198.6054-.5928.955-1.118.955H.0576L0 9.2444c.8468-.1838 1.8089-.4802 2.3917-.7973.3568-.1936.4586-.363.5757-.8233L4.9006.1459h2.562l3.9277 9.3706H8.8445"
      transform="matrix(1 0 0 -1 0 9.6877)"
      fill="url(#visa-a)"
      fillRule="nonzero"
      opacity={active ? '1' : '.25'}
    />
  </svg>
);

Visa.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
};

Visa.defaultProps = {
  active: true,
  className: '',
};

export default Visa;
